import React from 'react'

export default (props: any) => (
  <svg {...props} width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0.599976H49.9V50.5H0V0.599976Z" fill="#D80027" />
    <path d="M20.866 9.25H29.362V39.25H20.866V9.25Z" fill="white" />
    <path d="M10.2453 28.1289L10.2948 19.8691L40.2943 20.0492L40.2447 28.309L10.2453 28.1289Z" fill="white" />
    <path d="M0.5 0.5H50.5V50.5H0.5V0.5Z" stroke="#9F9D9D" />
  </svg>
)
